"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Campaign = void 0;
var Campaign = /** @class */ (function () {
    function Campaign(props) {
        this.page = 0;
        this.data = __assign(__assign({}, props.data), { eventInProgress: false, visitorSignedUp: false });
        this.renderer = props.renderer;
        this.logger = props.logger;
        this.tracker = props.tracker;
    }
    Campaign.prototype.getData = function () {
        return this.data;
    };
    Campaign.prototype.getPage = function () {
        return this.page;
    };
    Campaign.prototype.setVisitorSignedUp = function (value) {
        this.data.visitorSignedUp = value;
    };
    Campaign.prototype.setEventInProgress = function (value) {
        this.data.eventInProgress = value;
    };
    Campaign.prototype.getCoupon = function () {
        return this.data.coupon;
    };
    Campaign.prototype.setCoupon = function (value) {
        this.data.coupon = value;
    };
    Campaign.prototype.getEventInProgress = function () {
        return this.data.eventInProgress;
    };
    Campaign.prototype.render = function (page) {
        if (page === void 0) { page = this.page; }
        this.page = page;
        try {
            this.renderer.render(this.data, this.page);
            this.trackImpression();
            this.logger.trace("Campaign ".concat(this.data._id, " was rendered successfully"));
        }
        catch (error) {
            this.logger.error({ error: error }, "Something went wrong while rendering campaign ".concat(this.data._id));
        }
    };
    Campaign.prototype.refresh = function (page) {
        if (page === void 0) { page = this.page; }
        this.page = page;
        try {
            this.renderer.rerender(this.data, this.page);
            this.logger.trace("Campaign ".concat(this.data._id, " was rendered successfully"));
        }
        catch (error) {
            this.logger.error({ error: error }, "Something went wrong while rendering campaign ".concat(this.data._id));
        }
    };
    Campaign.prototype.trackImpression = function () {
        this.tracker.addImpression({ campaignID: this.data._id, isSession: false });
    };
    Campaign.prototype.destroy = function () {
        this.renderer.destroy();
    };
    Campaign.prototype.toString = function () {
        return JSON.stringify(this.data);
    };
    return Campaign;
}());
exports.Campaign = Campaign;
//# sourceMappingURL=data:application/json;base64,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